import { render, staticRenderFns } from "./PracticePeriods.vue?vue&type=template&id=7c36528c"
import script from "./PracticePeriods.vue?vue&type=script&lang=ts"
export * from "./PracticePeriods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports